export default {
    apiUri: 'https://api.cd-systeme.com',
    assetUrl: 'https://emilfrey-production.cd-systeme.rocks',
    pricing: 'gross',
    scrollToTop: true
}